"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeOption = TreeOption;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const components_1 = require("../../components");
const Css_1 = require("../../Css");
const CheckboxBase_1 = require("../CheckboxBase");
const TreeSelectField_1 = require("./TreeSelectField");
const Value_1 = require("../Value");
const utils_1 = require("../../utils");
/** Represents a single option within a ListBox - used by SelectField, MultiSelectField, and TreeSelectField */
function TreeOption(props) {
    var _a, _b;
    const { item, state, contrast = false, allowCollapsing = true } = props;
    const leveledOption = item.value;
    if (!leveledOption)
        return null;
    const [option, level] = leveledOption;
    // TODO: validate this eslint-disable with https://app.shortcut.com/homebound-team/story/40045
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const ref = (0, react_1.useRef)(null);
    // TODO: validate this eslint-disable with https://app.shortcut.com/homebound-team/story/40045
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { hoverProps, isHovered } = (0, react_aria_1.useHover)({});
    // TODO: validate this eslint-disable with https://app.shortcut.com/homebound-team/story/40045
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const tid = (0, utils_1.useTestIds)(props, "treeOption");
    // TODO: validate this eslint-disable with https://app.shortcut.com/homebound-team/story/40045
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { collapsedKeys, setCollapsedKeys, getOptionValue } = (0, TreeSelectField_1.useTreeSelectFieldProvider)();
    // TODO: validate this eslint-disable with https://app.shortcut.com/homebound-team/story/40045
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { optionProps, isDisabled, isFocused, isSelected } = (0, react_aria_1.useOption)({ key: item.key, shouldSelectOnPressUp: true, shouldFocusOnHover: false }, state, ref);
    // If this item is not selected, then determine if some of its children are selected to show the indeterminate state.
    // Note: If `isSelected` will be true if all of the children were selected. That auto-parent-selection happens in the `onSelect` callback in TreeSelectField.
    const isIndeterminate = !isSelected && ((_a = option.children) === null || _a === void 0 ? void 0 : _a.some((o) => hasSelectedChildren(o, state, getOptionValue)));
    const listItemStyles = {
        item: Css_1.Css.gray900.if(contrast).white.$,
        hover: Css_1.Css.bgGray100.if(contrast).bgGray600.$,
        disabled: Css_1.Css.cursorNotAllowed.gray400.if(contrast).gray500.$,
        focus: Css_1.Css.add("boxShadow", `inset 0 0 0 1px ${!contrast ? Css_1.Palette.Blue700 : Css_1.Palette.Blue500}`).$,
    };
    return ((0, jsx_runtime_1.jsxs)("li", { ...hoverProps, css: {
            ...Css_1.Css.df.aic.jcsb.gap1.pl2.mh("42px").outline0.cursorPointer.sm.plPx(16 + level * 8).$,
            ...listItemStyles.item,
            ...(isHovered && !isDisabled ? listItemStyles.hover : {}),
            ...(isFocused ? listItemStyles.focus : {}),
            ...(isDisabled ? listItemStyles.disabled : {}),
        }, children: [allowCollapsing && ((0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.wPx(18).fs0.df.aic.$, children: option.children && ((_b = option.children) === null || _b === void 0 ? void 0 : _b.length) > 0 && ((0, jsx_runtime_1.jsx)("button", { onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setCollapsedKeys((prevKeys) => collapsedKeys.includes(item.key) ? prevKeys.filter((k) => k !== item.key) : [...prevKeys, item.key]);
                        return false;
                    }, css: Css_1.Css.br4.hPx(16).wPx(16).bgTransparent.onHover.bgGray300.$, ...tid[`collapseToggle_${item.key}`], children: (0, jsx_runtime_1.jsx)(components_1.Icon, { icon: collapsedKeys.includes(item.key) ? "triangleRight" : "triangleDown", inc: 2 }) })) })), (0, jsx_runtime_1.jsxs)("span", { css: Css_1.Css.df.aic.gap1.h100.fg1.py1.pr2.$, ref: ref, ...optionProps, "data-label": item.textValue, children: [(0, jsx_runtime_1.jsx)(CheckboxBase_1.StyledCheckbox, { isDisabled: isDisabled, isSelected: isSelected, isIndeterminate: isIndeterminate, ...tid[item.key.toString()] }), (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.pl1.$, children: item.rendered })] })] }));
}
function hasSelectedChildren(childOption, state, getOptionValue) {
    if (childOption.children && childOption.children.length > 0) {
        return childOption.children.some((child) => hasSelectedChildren(child, state, getOptionValue));
    }
    return state.selectionManager.isSelected((0, Value_1.valueToKey)(getOptionValue(childOption)));
}
